import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TaskCheckbox from '../TaskCheckbox';
import TaskMetadata from '../TaskMetadata';
import styles from './TaskItem.module.css';
import { sanitizeText } from '../../../../../../utils/sanitize';

const TaskItem = ({ task, section, onTaskClick, onComplete }) => {
  const { t } = useTranslation();
  const [isCompleting, setIsCompleting] = useState(false);

  const handleCheckboxChange = async (e) => {
    e.stopPropagation(); // Prevent opening detail view
    const isChecked = e.target.checked;

    if (isChecked) {
      setIsCompleting(true);
      // Trigger completion after animation completes (600ms animation duration)
      setTimeout(() => {
        onComplete(true);
        setIsCompleting(false);
      }, 600);
    } else {
      onComplete(false);
    }
  };

  const handleTaskClick = (e) => {
    // Don't trigger if clicking on checkbox
    if (e.target.closest(`.${styles.taskCheckbox}`)) {
      return;
    }
    // Open record detail view (which has social features)
    onTaskClick();
  };

  const isCompleted = task.attributes?.isComplete || false;
  const priority = task.attributes?.priority;

  return (
    <div
      className={`${styles.taskItem} ${isCompleting ? styles.completing : ''} ${isCompleted ? styles.completed : ''}`}
      onClick={handleTaskClick}
      data-section={section}
    >
      {/* Priority indicator */}
      {priority && (
        <div className={`${styles.priority} ${styles[priority]}`} />
      )}

      <div className={styles.taskContent}>
        <div className={styles.taskCheckbox}>
          <TaskCheckbox
            checked={isCompleted}
            onChange={handleCheckboxChange}
          />
        </div>

        <div className={styles.taskDetails}>
          <h3 className={styles.taskTitle}>
            {sanitizeText(task.content.title) || t('records.views.task.item.untitled')}
          </h3>
          <TaskMetadata
            dueDate={task.attributes?.dueDate}
            dueDateSemantics={task.attributes?.dueDateSemantics}
            tags={task.content.tags}
            isComplete={isCompleted}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskItem;
